import { Dispatch, ThunkAction } from '../../../../../../../types/actions';
import { IGetState } from '../../../../../../../types/types';
import { root } from '../../../../../../../store/constants';
import { segmentTrackAction, SegmentUserEvent } from '../../../../../../../middlewares/segment';
import { getQualificationTemplateBoardIds } from '../selectors/getQualificationTemplateBoardIds';
import { createFirstBoard } from '../../../../../../../rest/effects/board/createFirstBoard';

export const onGetStarted = (): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        dispatch(segmentTrackAction(SegmentUserEvent.GET_STARTED_CLICKED));
        root.App.controller.mainView.qualificationDialog.remove();
        const qualificationTemplateBoardIds = getQualificationTemplateBoardIds(getState());
        if (qualificationTemplateBoardIds && qualificationTemplateBoardIds.length === 1) {
            dispatch(createFirstBoard(qualificationTemplateBoardIds[0]));
        } else if (qualificationTemplateBoardIds && qualificationTemplateBoardIds.length > 1) {
            root.App.controller.mainView.showTemplateSelectDialog();
        } else { // если скипнули, то грузим Quick Start
            dispatch(createFirstBoard());
        }
    };
    return action;
};
